import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { trainingApi } from "../../services";

export default function TrainingEffectivenessFeedback() {
  const navigate = useNavigate();
  const [expectedOutcome, setExpectedOutcome] = useState("");
  const [skillLevel, setSkillLevel] = useState(null);
  const [outcomeAchieved, setOutcomeAchieved] = useState(null);
  const [feedback, setFeedback] = useState("");
  const [skillLevelOptions, setSkillLevelOptions] = useState([]);

  useEffect(() => {
    fetchRatings();
  }, []);

  const fetchRatings = () => {
    trainingApi.getRatings().then((resp) => {
      resp.data.data.sort((a, b) => a.code - b.code);
      setSkillLevelOptions(resp.data.data);
    });
  };

  const handleSubmit = () => {
    const dataObj = {
      employeeName: "Khyati Gupta",
      expectedOutcome: expectedOutcome,
      skillLevel: skillLevel,
      outcomeAchieved: outcomeAchieved,
      feedback: feedback,
    };
    console.log(dataObj);
    // navigate("/training-validation")
  };

  return (
    <div className="card">
      <div className="col">
        <h1 className="p-0 training-heading">
          Training Effectiveness Feedback
        </h1>
        <hr></hr>
      </div>
      <div className="flex flex-wrap p-field font-bold block">
        <div className="col-6">
          <label
            htmlFor="employeeName"
            className="font-bold block mb-2 training-heading"
          >
            Employee Name
          </label>
          <div className="p-inputgroup flex-1">
            <span className="p-inputgroup-addon">
              <i className="pi pi-user"></i>
            </span>{" "}
            <InputText
              id="text"
              disabled
              placeholder="Khyati Gupta"
              className="w-full"
            />
          </div>
        </div>
        <div className="col-6">
          <label
            htmlFor="expectedOutcome"
            className="font-bold block mb-2 training-heading"
          >
            Expected Business Outcome
          </label>
          <InputText
            id="expectedOutcome"
            value={expectedOutcome}
            onChange={(e) => setExpectedOutcome(e.target.value)}
            rows={4}
            placeholder="Describe the expected outcome of the training"
            className="w-full"
            style={{ background: "#fff" }}
          />
        </div>
      </div>
      <div className="flex flex-wrap p-field font-bold block">
        <div className="col-6">
          <label
            htmlFor="skillLevel"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Skill Level Post Training
          </label>
          <Dropdown
            value={skillLevel}
            onChange={(e) => setSkillLevel(e.value)}
            options={skillLevelOptions}
            optionLabel={(option) => `${option.code} - ${option.title}`}
            placeholder="Select Skill Level"
            className="w-full"
          />
        </div>
        <div className="col-6">
          <label
            htmlFor="outcomeAchieved"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Outcome Achieved
          </label>
          <div className="flex align-items-center">
            <RadioButton
              inputId="yes"
              name="outcomeAchieved"
              value="Yes"
              onChange={(e) => setOutcomeAchieved(e.value)}
              checked={outcomeAchieved === "Yes"}
              className="mt-2"
            />
            <label htmlFor="yes" className="ml-2 mt-2">
              Yes
            </label>
            <RadioButton
              inputId="no"
              name="outcomeAchieved"
              value="No"
              onChange={(e) => setOutcomeAchieved(e.value)}
              checked={outcomeAchieved === "No"}
              className="ml-4 mt-2"
            />
            <label htmlFor="no" className="ml-2 mt-2">
              No
            </label>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap p-field font-bold block">
        <div className="col-12">
          <label
            htmlFor="feedback"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Feedback
          </label>
          <InputTextarea
            id="feedback"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            rows={4}
            placeholder="Provide your feedback"
            className="w-full"
            style={{ background: "#fff" }}
          />
        </div>
      </div>
      <div className="flex flex-wrap p-field font-bold block mt-4">
        <div className="col-12 flex">
          <Button
            label="Submit"
            onClick={() => navigate("/training-effectiveness-report")}
          />
          <Button
            label="Back"
            className="ml-2"
            severity="secondary"
            onClick={() => navigate("/training")}
          />
        </div>
      </div>
    </div>
  );
}
